export const CREATE_FIRM_ENABLER = 'createFirm';
export const DELETE_COMPANY_ENABLER = 'deleteCompany';
export const DELETE_MEASUREMENT_DATES_ENABLER = 'deleteMeasurementDates';
export const PROCESS_MANAGEMENT_ENABLER = 'processManagement';
export const DOCUMENT_GENERATION_JOBS = 'documentGenerationJobs';
export const FUND_INVESTMENTS_ENABLER = 'fundInvestments';
export const FUND_INTELLIGENCE_ENABLER = 'fundIntelligence';
export const DAILY_NAV_ENABLER = 'dailyNav';
export const NOTIFICATION_CENTER_ENABLER = 'notification_center';
export const AI_DASHBOARD_SUMMARIES_ENABLER = 'aiDashboardSummaries';

export const FLAGGED_FEATURE: { key: string; title: string; description: string }[] = [
  {
    key: CREATE_FIRM_ENABLER,
    title: 'Create Firm',
    description: '',
  },
  {
    key: DELETE_COMPANY_ENABLER,
    title: 'Delete Company',
    description: '',
  },
  {
    key: DELETE_MEASUREMENT_DATES_ENABLER,
    title: 'Delete Measurement Dates',
    description: '',
  },
  {
    key: PROCESS_MANAGEMENT_ENABLER,
    title: 'Process Management',
    description: '',
  },
  {
    key: DOCUMENT_GENERATION_JOBS,
    title: 'Document Processing Jobs',
    description:
      'Allows users to create document processing jobs that parse documents and create a Cap Table using AI.',
  },
  {
    key: FUND_INVESTMENTS_ENABLER,
    title: 'Fund Investments',
    description: '',
  },
  {
    key: FUND_INTELLIGENCE_ENABLER,
    title: 'Fund Intelligence',
    description: 'Enables the Fund Intelligence feature with tabs navigation for company summary.',
  },
  {
    key: DAILY_NAV_ENABLER,
    title: 'Daily NAV',
    description: 'Enables Daily NAV monitoring and reporting for the firm.',
  },
  {
    key: AI_DASHBOARD_SUMMARIES_ENABLER,
    title: 'AI Dashboard Summaries',
    description:
      'Enables creating AI-generated dashboard summary tabs from the summary tab "+" menu, alongside spreadsheet summaries.',
  },
];
